import { createSlice } from '@reduxjs/toolkit'

const sliceName = 'leftNavigation'

const initialState = {
  fixed: true,
  open: false
}

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setOpen: (state, action) => {
      state.open = action.payload
    },
    setVariant: (state, action) => {
      switch (action.payload) {
        case 'minimized':
        case 'phone':
          state.fixed = false
          state.open = false
          break
        case 'default':
          state.fixed = true
          state.open = false
          break
        case 'expanded':
          state.fixed = false
          state.open = true
          break
        default: break
      }
    }

  }
})

export const { reducer, actions: { setOpen, setVariant } } = slice
